// Interactable Mixin - C#のインターフェースに相当
export const InteractableMixin = {
  makeInteractable() {
    this.isInteractable = true
    this.isHovered = false

    // インタラクション可能オブジェクトとして登録
    if (this.experience && this.experience.interactionManager) {
      this.experience.interactionManager.addInteractableObject(this)
    }
  },
  
  // インタラクション時に呼ばれるメソッド（オーバーライド推奨）
  onInteract(intersectionData) {
    console.log('Object was clicked! : Mixin')
  },
  
  // ホバー時に呼ばれるメソッド
  onHover(intersectionData) {
    if (!this.isHovered) {
      this.isHovered = true

      // カーソルを変更
      document.body.style.cursor = 'pointer'
    }
  },
  
  // ホバー終了時に呼ばれるメソッド
  onHoverExit() {
    if (this.isHovered) {
      this.isHovered = false

      // カーソルを元に戻す
      document.body.style.cursor = 'default'
    }
  },

  // インタラクションを無効化
  disableInteraction() {
    this.isInteractable = false
    if (this.experience && this.experience.interactionManager) {
      this.experience.interactionManager.removeInteractableObject(this)
    }
  }
}